import React from "react";
import { FaFilePdf } from "react-icons/fa";
import { formatMessageTime, fileNameFromUrl } from "../../utils/consultationChatFormat";

const MessageBubble = ({
  msg,
  isOutgoing,
  peerInitial,
  staffId,
}) => {
  const isWelcome = msg._welcome;

  return (
    <div className={`flex gap-2 ${isOutgoing ? "justify-end" : "justify-start"}`}>
      {!isOutgoing && (
        <div className="w-8 h-8 rounded-full bg-surface-container shrink-0 flex items-center justify-center text-xs font-bold text-on-surface-variant mt-0.5">
          {isWelcome ? "S" : peerInitial}
        </div>
      )}
      <div
        className={`max-w-[85%] md:max-w-[75%] rounded-2xl px-4 py-2.5 text-sm ${
          isOutgoing
            ? "bg-[#0B6B53] text-white rounded-br-md"
            : "bg-surface-lowest border border-surface-container text-on-primary-fixed-var rounded-bl-md"
        }`}
      >
        {msg.message && <p className="whitespace-pre-wrap break-words">{msg.message}</p>}
        {msg.file && (
          <a
            href={msg.file}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex items-center gap-2 mt-2 p-2 rounded-lg text-xs ${
              isOutgoing ? "bg-white/10 text-white" : "bg-surface-low border border-surface-container text-on-primary-fixed-var"
            }`}
          >
            <FaFilePdf className="shrink-0 text-red-500" size={18} />
            <span className="truncate font-medium">{fileNameFromUrl(msg.file)}</span>
          </a>
        )}
        {msg.timestamp && (
          <p className={`text-[10px] mt-1.5 text-right ${isOutgoing ? "text-white/75" : "text-on-surface-variant"}`}>
            {formatMessageTime(msg.timestamp)}
          </p>
        )}
      </div>
    </div>
  );
};

export default MessageBubble;
